import { AlarmData } from './slice';
import { RootState } from '../../../app/reducer';

export const selectAlarms = ({ alarmReducer }: RootState): Array<AlarmData> =>
  alarmReducer.alarms;
